// import { Suspense } from "react";
// import AdminDashboard from "./AdminDashboard";
// import DutySchedule from "./DutySchedule";
// import PharmacyDashboard from "./PharmacyDashboard";
// import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
// import { BookIcon, ClockIcon, Layout, LayoutDashboardIcon } from "lucide-react";

// const LoadingSpinner = () => (
//   <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
//     <div className="text-center">
//       <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//       <p className="text-gray-600 font-medium">Chargement...</p>
//     </div>
//   </div>
// );

// function App() {

//    const menuItems = [
//     { icon: TrendingUp, label: 'Tableau de bord', active: true },
//     { icon: MessageSquare, label: 'Messages clients' },
//     { icon: FileText, label: 'Ordonnances' },
//     { icon: Package, label: 'Gestion du stock' },
//     { icon: Calendar, label: 'Horaires & Garde' },
//     { icon: Users, label: 'Mes clients' },
//     { icon: Settings, label: 'Ma pharmacie' },
//   ];

//   return (

//     <Router>
//       <Suspense fallback={<LoadingSpinner />}>
//         <Routes>
//           <Route path="/admin" element={<AdminDashboard />} />
//           <Route path="/pharmacist" element={<Layout menuItems={menuItems}><Outlet /></Layout>}>
//             <Route index element={<PharmacyDashboard />}></Route>
//             <Route path="garde" element={<DutySchedule />}></Route>
//           </Route>
//           <Route path="/dutyschedule" element={<DutySchedule />} />
//         </Routes>
//       </Suspense>
//     </Router>
//     // <PharmacyDashboard />
//     // <AdminDashboard />
//     // <DutySchedule />
//   );
// }


// export default App;


import { Suspense, lazy, useEffect, useRef, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import PharmacyLayout from "./PharmacyLayout";
import PatientMessaging from "./Patientmessaging";
import PharmacistManagement from "./Pharmacistmanagement";
import PharmacyManagement from "./Pharmacymanagement";
import AdminDashboardLayout from "./AdminDashboardLayout";
import AdminSettings from "./Adminsettings";
import AdminMessaging from "./Adminmessaging";
import UserManagement from "./UserManagement";
import Login from "./components/Auth/Login";
import AdminLogin from "./components/Auth/AdminLogin";
import SyndicatDashboard from "./SyndicatDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import PharmacistMessaging from "./PharmacistMessaging";
import PharmacyDutySchedule from "./Pharmacydutyschedule";
import VendorManagement from "./Vendormanagement";
import StockManagement from "./Stockmanagement";
import PrescriptionManagement from "./Prescriptionmanagement";
import PrescriptionRegistry from "./Prescriptionregistry";
import SalesInterface from "./Salesinterface";
import SimpleStockManagement from "./Simplestockmanagement";
import PrescriptionCalculator from "./Prescriptioncalculator";
import LabOrderInterface from "./Laborderinterface";
import ImprovedLabOrderInterface from "./Improvedlaborderinterface";
import ImprovedSalesInterface from "./Improvedsalesinterface";
import ImprovedPharmacyDutySchedule from "./Improvedpharmacydutyschedule";
import MutuelleManagement from "./Mutuellemanagement ";
import PharmacienDashboard from "./Pharmaciendashboard";
import EmployeeDashboard from "./Employeedashboard";
import PharmacienDashboardAdvanced from "./Pharmaciendashboardadvanced";
import MonSyndicat from "./MonSyndicat";
import MaPharmacie from "./MaPharmacie";
import HorairesGarde from "./HorairesGarde";
import PharmacyManagementUnified from "./PharmacyManagementUnified";
import PharmacyManagementFinal from "./Pharmacymanagementfinal";
import MutuelleManagementsobre from "./Mutuellemanagementsobre";
import ReportsSobre from "./Rapports.jsx";
import Livraison from "./Livraison.jsx";
import LivraisonOperateur from "./LivraisonOperateur.jsx";
// import SunuFarmasiLandingPage from "./SunuFarmasiLandingPage";

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600 font-medium">Chargement...</p>
    </div>
  </div>
);

// Lazy imports
// const Login = lazy(() => import("./pages/Login"));
const AdminDashboard = lazy(() => import("./AdminDashboard"));
const PharmacyDashboard = lazy(() => import("./PharmacyDashboard"));
const DutySchedule = lazy(() => import("./DutySchedule"));

// ─── Déconnexion automatique après 5 min d'inactivité ────────────────────────
const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

function IdleLogoutHandler() {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = useCallback(() => {
    const token = localStorage.getItem("token");
    if (!token) return; // Pas connecté, rien à faire
    const role = localStorage.getItem("role") || "";
    localStorage.clear();
    sessionStorage.setItem("autoLogout", "true");
    navigate(role === "syndicat" ? "/login" : "/admin-login", { replace: true });
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, IDLE_TIMEOUT_MS);
  }, [logout]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();
    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  return null;
}
// ─────────────────────────────────────────────────────────────────────────────

function App() {
  return (
    <Router>
      <IdleLogoutHandler />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* Routes Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboardLayout />
                {/* <PharmacyManagement /> */}
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="pharmacist" element={<PharmacistManagement />} />
            <Route path="pharmacies" element={<PharmacyManagement />} />
            <Route path="network" element={<PharmacyManagementFinal />} />
            {/* <Route path="network" element={<PharmacyManagementUnified />} /> */}
            <Route path="dutschedule" element={<DutySchedule />} />
            {/* <Route path="messages" element={<UserManagement />} /> */}
            <Route path="messages" element={<AdminMessaging />} />
            <Route path="settings" element={<AdminSettings />} />


            <Route path="rapport" element={<ReportsSobre />} />
            <Route path="livraisons" element={<LivraisonOperateur />} />
          </Route>

          {/* Routes Pharmacien avec Layout — V1 */}
          <Route
            path="/pharmacist"
            element={
              <ProtectedRoute role="pharmacien">
                <PharmacyLayout />
              </ProtectedRoute>
            }
          >
            {/* V1 — Routes actives */}
            <Route index element={<PharmacyDashboard />} />
            <Route path="garde" element={<HorairesGarde />} />
            <Route path="vendor" element={<VendorManagement />} />
            <Route path="syndicat"    element={<MonSyndicat />} />
            <Route path="ma-pharmacie" element={<MaPharmacie />} />
            {/* <Route path="settings" element={<AdminSettings />} /> */}

            {/* V2+ — Routes commentées (ne pas supprimer) */}
            {/* <Route path="stock" element={<StockManagement />} /> */}
            {/* <Route path="lab" element={<ImprovedLabOrderInterface />} /> */}
            {/* <Route path="calcule" element={<PrescriptionCalculator />} /> */}
            {/* <Route path="simple" element={<SimpleStockManagement />} /> */}
            {/* <Route path="sales" element={<ImprovedSalesInterface />} /> */}
            {/* <Route path="registry" element={<PrescriptionRegistry />} /> */}
            {/* <Route path="medocs" element={<PrescriptionManagement />} /> */}
            {/* <Route path="messagespharmacist" element={<PharmacistMessaging />} /> */}
            {/* <Route path="messages" element={<PatientMessaging />} /> */}
            {/* <Route path="mutuelle" element={<MutuelleManagementsobre />} /> */}
            {/* <Route path="dash" element={<PharmacienDashboardAdvanced />} /> */}
            {/* <Route path="dashEmp" element={<EmployeeDashboard />} /> */}
            {/* <Route path="livraison" element={<Livraison />} /> */}
          </Route>

          {/* Routes Syndicat */}
          <Route
            path="/syndicat"
            element={
              <ProtectedRoute role="syndicat">
                <SyndicatDashboard />
              </ProtectedRoute>
            }
          />

          {/* Super Admin */}
          <Route
            path="/super-admin"
            element={
              <ProtectedRoute role="admin">
                <SuperAdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Redirections */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          {/* <Route path="/landingpage" element={<SunuFarmasiLandingPage />} /> */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;